import { render } from "./CancelPackage.vue?vue&type=template&id=025a4331&scoped=true"
import script from "./CancelPackage.vue?vue&type=script&lang=js"
export * from "./CancelPackage.vue?vue&type=script&lang=js"

import "./CancelPackage.vue?vue&type=style&index=0&id=025a4331&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025a4331"]])

export default __exports__